import { Cache } from "../../../../infra3d/utils/cache";
import { fetchAllData, fetchData } from "../util";
import { boundaryFilter, propertyFilter } from "../projectscope";
export class CampaignProvider {
    constructor(apiHost, authObject, projectScope, cacheSize = 50000) {
        this._apiHost = new URL(apiHost);
        this._authObject = authObject;
        this._projectScope = projectScope;
        this._cache = new Cache(cacheSize, false);
    }
    allCampaigns(collection, onSuccess, onError, bbox) {
        try {
            const cacheKey = `allCampaigns(${collection}, ${bbox?.minEasting}, ${bbox?.maxEasting}, ${bbox?.maxNorthing}, ${bbox?.maxNorthing}, ${bbox?.epsg})`;
            const cached = this._cache.getItem(cacheKey);
            if (cached !== null) {
                onSuccess(cached);
                return;
            }
            const error = new Error("Data is invalid.");
            const _propertyFilter = propertyFilter("campaigns", {
                projectScope: this._projectScope,
            });
            const _boundaryFilter = boundaryFilter({
                projectScope: this._projectScope,
                boundary: bbox,
            });
            let url = `${this._apiHost.href}/campaigns/${collection}/query`;
            if (_propertyFilter.length > 0) {
                url = url.concat(`?${_propertyFilter}`);
            }
            fetchAllData(fetchData, url, "POST", (campaigns) => {
                if (campaigns === undefined || !Array.isArray(campaigns)) {
                    onError(error);
                    return;
                }
                for (const campaign of campaigns) {
                    this._cache.setItem(`getCampaign(${collection}, ${campaign.uid})`, campaign, null);
                }
                this._cache.setItem(cacheKey, campaigns, null);
                onSuccess(campaigns);
            }, onError, this._apiHost.origin, this._authObject, { boundary: _boundaryFilter });
        }
        catch (error) {
            if (error.message === "No intersection of boundary") {
                onSuccess([]);
                return;
            }
        }
    }
    getCampaign(collection, uid, onSuccess, onError) {
        const cacheKey = `getCampaign(${collection}, ${uid})`;
        const cached = this._cache.getItem(cacheKey);
        if (cached !== null) {
            onSuccess(cached);
            return;
        }
        const error = new Error("Data is invalid.");
        const _propertyFilter = propertyFilter("campaigns", {
            projectScope: this._projectScope,
        });
        let url = `${this._apiHost.href}/campaigns/${collection}/${uid}`;
        if (_propertyFilter.length > 0) {
            url = url.concat(`?${_propertyFilter}`);
        }
        fetchData(url, "GET", (campaign) => {
            if (campaign === undefined) {
                onError(error);
                return;
            }
            this._cache.setItem(cacheKey, campaign, null);
            onSuccess(campaign);
        }, onError, this._authObject);
    }
}
//# sourceMappingURL=campaignprovider.js.map